import { useEffect } from "react";

import { EnhancedPhoneNumber } from "../../../../Models/PhoneNumber";
import { useGem } from "../../../../Utils/UseGem";

interface PhoneNumberListItem extends EnhancedPhoneNumber {
  show: boolean;
}

const useGetPhoneNumbers = () => {
  const { res, setReq } = useGem<PhoneNumberListItem[]>();
  useEffect(() => setReq({ url: "Legacy/V0/PhoneNumbers", config: { params: { isAdmin: true } } }), []);
  return { res };
};

export default useGetPhoneNumbers;
